import { format } from 'date-fns'
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { imageJitURL } from '@src/utils/imageJitURL'

import { OrderProgress } from './OrderProgress'
import {
  StatusBoxContainer,
  StatusBoxUpdate,
  StatusPhotoText,
  StatusBoxText,
  StatusBoxTextHeader,
  StatusBoxPlaced,
  RestaurantLogo,
  StatusInfoContainer,
} from './StatusBox.styles'

export const CompleteStatusBox: React.VFC<{
  updatedAt: string
  restaurantName: string
  restaurantLogo: string | null
  isAccountPage: boolean
}> = ({ updatedAt, restaurantLogo, restaurantName, isAccountPage }) => {
  const orderUpdatedAt = formatDistanceToNow(new Date(updatedAt), {
    addSuffix: true,
  })
  const { t } = useTranslation('singleOrder')

  return (
    <StatusBoxContainer isAccountPage={isAccountPage}>
      <StatusBoxPlaced>
        {format(new Date(updatedAt), 'dd MMM yyyy')}
      </StatusBoxPlaced>
      <StatusBoxUpdate>
        {t('updated')} {orderUpdatedAt}
      </StatusBoxUpdate>
      <StatusPhotoText>
        <RestaurantLogo
          role="img"
          aria-label={`${restaurantName} logo`}
          imageUrl={imageJitURL(restaurantLogo, {
            resize: {
              width: 128,
              height: 128,
              fit: 'cover',
            },
            toFormat: 'jpeg',
          })}
        />
        <StatusInfoContainer>
          <StatusBoxTextHeader>{restaurantName}</StatusBoxTextHeader>
          <StatusBoxText>{t('order_complete')}</StatusBoxText>
        </StatusInfoContainer>
      </StatusPhotoText>
      <OrderProgress valueNow={4} />
    </StatusBoxContainer>
  )
}
